import React, { useEffect, useState } from "react";
import { Building2, ChevronsUpDown } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export function HotelSwitcher({ user }) {
    const [hotels, setHotels] = useState([]);
    const multi = (user?.hotel_ids || []).length > 1;

    useEffect(() => {
        if (multi) api.get("/auth/my-hotels").then((r) => setHotels(r.data.items || [])).catch(() => {});
    }, [multi]);

    if (!multi) return null;

    const onSwitch = async (hotel_id) => {
        try {
            await api.post("/auth/switch-hotel", { hotel_id });
            window.location.assign("/h/dashboard");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Otel değiştirilemedi");
        }
    };

    return (
        <div className="px-3 pt-3">
            <div className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-1 px-1">Aktif Otel</div>
            <label className="relative flex items-center gap-2 px-3 py-2 rounded-xl bg-emerald-50 dark:bg-emerald-950/30 border border-emerald-200 dark:border-emerald-900">
                <Building2 className="h-4 w-4 text-emerald-600 flex-shrink-0" />
                <select data-testid="hotel-switcher" value={user.hotel_id || ""} onChange={(e) => onSwitch(e.target.value)} className="appearance-none w-full bg-transparent outline-none text-sm font-semibold text-slate-900 dark:text-white pr-5 cursor-pointer">
                    {hotels.map((h) => <option key={h.id} value={h.id}>{h.name}</option>)}
                </select>
                <ChevronsUpDown className="h-4 w-4 text-slate-400 absolute right-3 pointer-events-none" />
            </label>
        </div>
    );
}
